import { Link } from "react-router-dom";
import useSeo from "@/lib/useSeo";

export default function NotFound() {
  useSeo("Page not found");
  return (
    <div data-testid="not-found-page" className="px-6 sm:px-16 py-32">
      <p className="font-serif-mm text-6xl">Lost, <em className="text-[var(--mm-red)]">beautifully.</em></p>
      <Link to="/" className="btn-mm mt-10">Return home</Link>
    </div>
  );
}
